import { STATUS_VALUE_ZERO, STATUS_ZERO } from "../../components/attendance/Constants";
import { editTeam } from "../../config/services/employeeServices";
import ResponseFilter from "../../ResponseFilter";
import {
    EDIT_TEAM_REQUEST,
    EDIT_TEAM_SUCCESS,
    EDIT_TEAM_FAILURE,
} from "./actionType";


const editTeamByAdminAction = (props) => {
    let { useDispatch, closeModal, getTeam, obj } = props
    return (dispatch) => {
        dispatch(editTeamByAdminRequest());
        editTeam(obj).then((res) => {
            let { status } = ResponseFilter(res)
            if (status) {
                useDispatch({
                    type: 'typeCheckSet', payload: {
                        resTeamMsg: true,
                        loader: false,
                        successMessage: "Team Edited"
                    }
                })
                getTeam()
                closeModal()
                setTimeout(() => useDispatch({
                    type: 'typeCheckSet', payload: {
                        resTeamMsg: false
                    }
                }), 3000);
            } else if (res.data.statusCode === STATUS_VALUE_ZERO) {
                useDispatch({
                    type: 'typeCheckSet', payload: {
                        responseMessage: res.data.error.responseMessage,
                        errorCode: res.data.error.errorCode,
                        resTeamFailMsg: true,
                        loader: false
                    }
                })
                setTimeout(() => useDispatch({
                    type: 'typeCheckSet', payload: {
                        resTeamFailMsg: false
                    }
                }), 3000);
            }
            getTeam()
        })
            .catch((error) => {
                dispatch(editTeamByAdminFailure(error));
                // setErrorText("Failed to add");
                // setFailResMsg(true);
            });
    };
};

const editTeamByAdminRequest = () => {
    return {
        type: EDIT_TEAM_REQUEST,
    };
};
const editTeamByAdminSuccess = (data) => {
    return {
        type: EDIT_TEAM_SUCCESS,
        payload: data,
    };
};
const editTeamByAdminFailure = (error) => {
    return {
        type: EDIT_TEAM_FAILURE,
        payload: error,
    };
};
export {
    editTeamByAdminAction,
    editTeamByAdminRequest,
    editTeamByAdminSuccess,
    editTeamByAdminFailure,
};